/**
 * LIVERA SHIELD — CRO HOMEPAGE JS
 * - Scroll reveal animaties
 * - Statistieken count-up
 * - Viewer count fluctuatie
 * - FAQ accordion
 */

(function () {
  'use strict';

  // ── Scroll Reveal ──────────────────────────────────────────
  function initReveal() {
    var elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  // ── Count-up animatie ──────────────────────────────────────
  function countUp(el, target, duration) {
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = Math.floor(eased * target);
      el.textContent = current + (target >= 100 ? '+' : '');
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target + (target >= 100 ? '+' : '');
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll('.hp-stat__number[data-target]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-target'), 10);
          countUp(el, target, 1200);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function (el) { observer.observe(el); });
  }

  // ── Viewer count fluctuatie ────────────────────────────────
  function initViewerCount() {
    var el = document.getElementById('hp-viewers');
    if (!el) return;

    var current = 24;

    function fluctuate() {
      var delta = Math.floor(Math.random() * 5) - 2; // -2 tot +2
      current = Math.max(18, Math.min(31, current + delta));
      el.textContent = current;
      setTimeout(fluctuate, 6000 + Math.random() * 4000);
    }

    setTimeout(fluctuate, 8000);
  }

  // ── FAQ Accordion ──────────────────────────────────────────
  function initFaq() {
    var questions = document.querySelectorAll('.hp-faq__question');
    if (!questions.length) return;

    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = btn.nextElementSibling;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Sluit alle andere
        questions.forEach(function (otherBtn) {
          if (otherBtn !== btn) {
            otherBtn.setAttribute('aria-expanded', 'false');
            var otherAnswer = otherBtn.nextElementSibling;
            if (otherAnswer) otherAnswer.classList.remove('open');
          }
        });

        // Toggle huidige
        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          answer.classList.remove('open');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('open');
        }
      });
    });
  }

  // ── Init ───────────────────────────────────────────────────
  function init() {
    initReveal();
    initCounters();
    initViewerCount();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
